// store/modules/user.js
import {
	headuser
} from '@/api/com'

const state = {
	token: localStorage.getItem('token') || '',
	userInfo: JSON.parse(localStorage.getItem('headuser')) || {},
	provinceId: localStorage.getItem('provinceId') || '',
	provinceName: localStorage.getItem('provinceName') || '',
	hasLogin: !!localStorage.getItem('token')
}

const mutations = {
	SET_TOKEN(state, token) {
		state.token = token
		state.hasLogin = !!token
		localStorage.setItem('token', token)
	},
	SET_USER_INFO(state, userInfo) {
		state.userInfo = userInfo
		localStorage.setItem('headuser', JSON.stringify(userInfo))
	},
	SET_PROVINCE(state, {
		provinceId,
		provinceName
	}) {
		state.provinceId = provinceId
		state.provinceName = provinceName
		localStorage.setItem('provinceId', provinceId)
		localStorage.setItem('provinceName', provinceName)
	},
	CLEAR_USER(state) {
		state.token = ''
		state.userInfo = {}
		state.hasLogin = false
		localStorage.removeItem('token')
		localStorage.removeItem('headuser')
		sessionStorage.clear()
	}
}

const actions = {
	// 获取用户信息
	async getUserInfo({
		commit,
		state
	}, needRequest = false) {
		if (!needRequest && state.userInfo?.id) {
			return state.userInfo
		}

		try {
			const req = state.provinceId ? {
				province_id: state.provinceId
			} : {}
			const res = await headuser(req)
			const userData = res.data

			commit('SET_USER_INFO', userData)
			commit('SET_PROVINCE', {
				provinceId: userData.province_id || '',
				provinceName: userData.province_name || ''
			})

			return userData
		} catch (err) {
			console.error('获取用户信息失败：', err)
			return null
		}
	},

	// 登录
	login({
		commit
	}, token) {
		commit('SET_TOKEN', token)
	},

	// 退出登录
	logout({
		commit
	}) {
		commit('CLEAR_USER')
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}